<!--
 * @Author: your name
 * @Date: 2021-10-09 08:12:36
 * @LastEditTime: 2022-01-14 09:12:32
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\components\cart\SimpleCart.vue
-->
<template>
    <div class="header_cart" @click="toCart" :style="{'left': leftValue+'px'}">
        <img width="26px" height="24px" class="cat_img"
            src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/index/index_cart.png"/>
        <span class="cart_text">购物车<span class="mainFontColor"> ( {{cartCount}} ) </span></span>
    </div>
</template>
<script>
import Bus from '@/api/bus/bus.js'
import {countCartGoodsData} from '@/api/cartApi'
export default {
    data() {
        return {
            cartCount: 0
        };
    },
    props:{ leftValue:null},
    mounted() {
        const token = this.$store.getters.getToken;
        if (token) {
            this.countCartGoods();
        }

        Bus.$on('changeCartNum',() => {
            this.countCartGoods()
        })
    },
    computed: {},
    methods: {
        toCart() {
            this.$router.push({ path: "/cart/cartList",});
        },
        countCartGoods: function() {
            countCartGoodsData().then(res => {
                if (res.success) {
                    this.cartCount = res.data;
                }
            })
        }
    }
};
</script>
<style scoped>
.header_cart {
  width: 133px;
  height: 40px;
  line-height: 40px;
  position: relative;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 20px;
  text-align: center;
  cursor: pointer;
  margin-top: -6px;
}
.cart_text {
  width: 60px;
  height: 12px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 36px;
}
.cat_img {
  display: inline-block;
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/cart/SimpleCart.vue